import { render } from "./SettingConnect.vue?vue&type=template&id=07af4762&scoped=true"
import script from "./SettingConnect.vue?vue&type=script&lang=js"
export * from "./SettingConnect.vue?vue&type=script&lang=js"

import "./SettingConnect.vue?vue&type=style&index=0&id=07af4762&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07af4762"]])

export default __exports__